import { classNames } from '@common/application/utils/classnames';
import { getLocaleValue } from '@common/application/utils/get-locale-value';
import type { ProductDetailVO } from '@common/types/product-detail';

export interface AttrbuteProps {
  attrId: string;
  name: string;
  products: (ProductDetailVO | undefined)[];
}

export const Attrbute: React.FC<AttrbuteProps> = ({ attrId, name, products }) => {
  function renderText(text: string) {
    return (
      <div
        className={classNames('flex items-center px-3 w-37.5 h-8.5', 'pc:px-7.5 pc:w-62.5 pc:h-13')}
      >
        <span className={classNames('text-xs text-black-1 font-normal line-clamp-1', 'pc:text-sm')}>
          {text}
        </span>
      </div>
    );
  }

  return (
    <tr>
      <th className="bg-black-9 border border-black-7"> {renderText(name)}</th>
      {products.map((product) => {
        const value = getLocaleValue(product?.simpleProductVo.offlineCategories?.[attrId]) || '-';
        return (
          <td key={product?.simpleProductVo.csku} className="border border-black-7">
            {renderText(value)}
          </td>
        );
      })}
    </tr>
  );
};
